(function () {
  'use strict';

  angular.module('app').component('bookingItemCostTable', bookingItemCostTable());

  function bookingItemCostTable() {
    return {
      bindings: {
        bookingItem: '<',
        currency: '<',
      },
      controller: function () {},
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/components/' +
        'booking-item-cost-table/booking-item-cost-table.component.html',
    };
  }
})();
